import React,{Component} from 'react';
import {variables} from '../../Variables.js';
import Alert from "../../components/Alert.jsx";
import MyPage from "../../MyPage.js";
import SubTabsDashboard from "../../SubTabsDashboard.js";
import { Blocks } from 'react-loader-spinner'
import axiosService from '../../helpers/axios';

  export default class DashboardBudgetAnalysis extends Component{ 

    constructor(props){
      super(props);

      this.state={
          budgetdeviationyear:[],
          modalTitle:"",
          bdyid: 0,
		      budget_type_y: "",
		      fyname_y: "",
		      july_y:"",
		      august_y: "",
		      september_y: "",
		      october_y: "",
		      november_y: "",
		      december_y: "",
		      january_y: "",
		      february_y: "",
		      march_y: "",
		      april_y: "",
		      may_y: "",
		      june_y: "",
        

          budgetdeviationwarehouse:[],
          bdwid: 0,
		      budget_type_w: "",
		      fyname_w: "",
		      regionname_w: "",
		      warehousename_w: "",
          july_w:"",
		      august_w: "",
		      september_w: "",
		      october_w: "",
		      november_w: "",
		      december_w: "",
		      january_w: "",
		      february_w: "",
		      march_w: "",
		      april_w: "",
		      may_w: "",
		      june_w: "",

          FiscalYearBdyFilter:"",
          BdyIdFilter:"",


          FiscalYearBdwFilter:"",
          BdwIdFilter:"",
          WarehouseNameFilter:"",
          RegionNameFilter:"",
          
          budgetdeviationyearWithoutFilter:[],
          budgetdeviationwarehouseWithoutFilter:[],

          fiscalYears: [], 
          warehouseNames: [],
          loading: true,

      }
  }


  
  getCurrentFinancialYearAndMonth() {
    const today = new Date();
    let fiscalYear = "";
    let fiscalMonth = "";
  
    // Determine fiscal year
    if ((today.getMonth() + 1) <= 6) {
      fiscalYear = (today.getFullYear());
    } else {
      fiscalYear = today.getFullYear() + 1;
    }
  
    // Determine fiscal month
    fiscalMonth = (today.getMonth() + 1); // Adding 1 as months are 0-indexed
  
    return {
      fiscalYear: fiscalYear,
      fiscalMonth: fiscalMonth
    };
  }


  getFirstWarehouseName = () => {
    const { warehouseNames } = this.state;
    return warehouseNames.length > 0 ? warehouseNames[0] : null;
  };




  FilterFn(){
    var FiscalYearBdyFilter = this.state.FiscalYearBdyFilter;
    var BdyIdFilter = this.state.BdyIdFilter;

    var filteredData=this.state.budgetdeviationyearWithoutFilter.filter(
        function(el){
            return el.bdyid.toString().toLowerCase().includes(
                BdyIdFilter.toString().trim().toLowerCase()
            )&&  
                el.fyname_y.toString().toLowerCase().includes(
                FiscalYearBdyFilter.toString().trim().toLowerCase()
            )
        }
    );

    this.setState({budgetdeviationyear:filteredData});

}

sortResult(prop,asc){
  var sortedData=this.state.budgetdeviationyearWithoutFilter.sort(function(a,b){
      if(asc){
          return (a[prop]>b[prop])?1:((a[prop]<b[prop])?-1:0);
      }
      else{
          return (b[prop]>a[prop])?1:((b[prop]<a[prop])?-1:0);
      }
  });

  this.setState({budgetdeviationyear:sortedData});

}


FilterFnO(){
  var FiscalYearBdwFilter = this.state.FiscalYearBdwFilter;
  var BdwIdFilter = this.state.BdwIdFilter;
  var WarehouseNameFilter = this.state.WarehouseNameFilter;
  var RegionNameFilter = this.state.RegionNameFilter;

  var filteredData=this.state.budgetdeviationwarehouseWithoutFilter.filter(
      function(el){
          return el.bdwid.toString().toLowerCase().includes(
              BdwIdFilter.toString().trim().toLowerCase()
          )&&  
              el.fyname_w.toString().toLowerCase().includes(
                FiscalYearBdwFilter.toString().trim().toLowerCase()
          )&&  
          el.regionname_w.toString().toLowerCase().includes(
            RegionNameFilter.toString().trim().toLowerCase()
      )&&  
      el.warehousename_w.toString().toLowerCase().includes(
        WarehouseNameFilter.toString().trim().toLowerCase()
  )
      }
  );

  this.setState({budgetdeviationwarehouse:filteredData});

}

sortResultO(prop,asc){
var sortedData=this.state.budgetdeviationwarehouseWithoutFilter.sort(function(a,b){
    if(asc){
        return (a[prop]>b[prop])?1:((a[prop]<b[prop])?-1:0);
    }
    else{
        return (b[prop]>a[prop])?1:((b[prop]<a[prop])?-1:0);
    }
});

this.setState({budgetdeviationwarehouse:sortedData});

}


changeBdyIdFilterFilter = (e)=>{
  this.state.BdyIdFilter=e.target.value;
  this.FilterFn();
}

changeFiscalYearBdyFilter = (e)=>{
  this.state.FiscalYearBdyFilter=e.target.value;
  this.FilterFn();
}


changeBdwIdFilterFilter = (e)=>{
  this.state.BdwIdFilter=e.target.value;
  this.FilterFnO();
}

changeFiscalYearBdwFilter = (e)=>{
  this.state.FiscalYearBdwFilter=e.target.value;
  this.FilterFnO();
}

changeRegionNameFilter = (e)=>{
    this.state.RegionNameFilter=e.target.value;
    this.FilterFnO();
  }

  changeWarehouseNameFilter = (e)=>{
    this.state.WarehouseNameFilter=e.target.value;
    this.FilterFnO();
  }



refreshListYear = () => {
    axiosService.get('/budgetdeviationyear/')
      .then((response) => {
        const data = response.data?.results ?? response.data;
        const { fiscalYear, fiscalMonth } = this.getCurrentFinancialYearAndMonth();
        const fiscalYearString = String(fiscalYear);
        const filteredData = data.filter(item => item.fyname_y === fiscalYearString);
        this.setState({ budgetdeviationyear: filteredData, budgetdeviationyearWithoutFilter: data, loading: false });
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        this.setState({ loading: false });
      });
  };


  refreshListWarehouse = () => {
    axiosService.get('/budgetdeviationwarehouse/')
      .then((response) => {
        const data = response.data?.results ?? response.data;
        const { fiscalYear, fiscalMonth } = this.getCurrentFinancialYearAndMonth();
        const fiscalYearString = String(fiscalYear);
        const firstWarehouseName = this.getFirstWarehouseName();
        const filteredData = data.filter(item => item.fyname_w === fiscalYearString && item.warehousename_w === firstWarehouseName  );
        this.setState({ budgetdeviationwarehouse: filteredData, budgetdeviationwarehouseWithoutFilter: data, loading: false });
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        this.setState({ loading: false });
      });
  };


  

fetchFiscalYears() {
  axiosService.get('/years/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const filteredData = data.filter(item => item.isactive === true);
      const fiscalYears = filteredData.map(item => item.fyname);
      this.setState({ fiscalYears: fiscalYears });
    })
    .catch(error => {
      console.error("Error fetching fiscal years:", error);
    });
}

fetchWarehouseNames() {
  axiosService.get('/warehouses/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const filteredData = data.filter(item => item.isactive === true);
      const warehouseNames = filteredData.map(item => item.warehousename);
      this.setState({ warehouseNames: warehouseNames });
    })
    .catch(error => {
      console.error("Error fetching warehouse names:", error);
    });
}




componentDidMount(){
  this.refreshListYear();
  this.refreshListWarehouse();
  this.fetchFiscalYears();
  this.fetchWarehouseNames();
}

componentWillUnmount() {
  // Clean up the interval when the component unmounts
  clearInterval(this.createClickInterval);
}



render(){
  const {
    budgetdeviationyear,
    bdyid,
    budget_type_y,
    fyname_y,
    july_y,
    august_y,
    september_y,
    october_y,
    november_y,
    december_y,
    january_y,
    february_y,
    march_y,
    april_y,
    may_y,
    june_y,
  

    budgetdeviationwarehouse,
    bdwid,
    budget_type_w,
    fyname_w,
    regionname_w,
    warehousename_w,
    july_w,
    august_w,
    september_w,
    october_w,
    november_w,
    december_w,
    january_w,
    february_w,
    march_w,
    april_w,
    may_w,
    june_w,
      loading,
      fiscalYears,
      warehouseNames
		   

  }=this.state;



  //const currentYear = fiscalYears[currentYearIndex];

  return(
    
<div className="scrollable-container">
<MyPage />
<SubTabsDashboard />
<div style={{ textAlign: 'left', fontWeight: 'bold',padding:"10px", fontSize: "14px" }}>
      Year Budget Deviation
    </div>

  <tr className="header-row-fixed">
  <td colSpan="2"> 
    <div className="input-group-container" style={{ display: "flex", justifyContent: "space-between", gap: "10px" }}>
    <div className="input-group mb-3" style={{ flex: 1 }}>
          <span className="input-group-text" style={{ fontSize: "12px" }} >Fiscal Year</span>
          <select
            className="form-select"
            value={this.state.fyname}
            onChange={this.changeFiscalYearBdyFilter}
            disabled={this.state.isEditClicked}
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select fiscal year</option>
            {this.state.fiscalYears.map((fiscalyear) => (
              <option key={fiscalyear} value={fiscalyear}>
                {fiscalyear}
              </option>
            ))}
          </select>
        </div>
        </div>
  </td>
  </tr>

<div className="table-container-budget">
  
<table className="table table-striped">
<thead>
<tr className="header-row-fixed">

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      BudgetType
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">

      </div>
      Fiscal Year
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Jul
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Aug
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Sep
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Oct
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Nov
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Dec
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Jan
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Feb
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Mar
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Apr
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      May
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Jun
  </th>
  
</tr>
</thead>
{loading ? (
          <div style={{ display: 'flex',flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '40vh', width:'150vh' }}>
            {/* Use react-loader-spinner here */}
            <Blocks visible={true} height="100" width="100" ariaLabel="blocks-loading" wrapperStyle={{}} wrapperClass="blocks-wrapper"/>
            <div style={{ marginLeft: '10px' }}>Loading...</div>
          </div>
        ) : (
<tbody>
  {budgetdeviationyear.map(dep=>
      <tr key={dep.bdyid} className="row-hover">
        <td className="table-text">{dep.budget_type_y ?? 'N/A'}</td>
        <td className="table-text">{dep.fyname_y ?? 'N/A'}</td>
<td className="table-text">{dep.july_y ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.july_y) : ''}</td>
<td className="table-text">{dep.august_y ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.august_y) : ''}</td>
<td className="table-text">{dep.september_y ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.september_y) : ''}</td>
<td className="table-text">{dep.october_y ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.october_y) : ''}</td>
<td className="table-text">{dep.november_y ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.november_y) : ''}</td>
<td className="table-text">{dep.december_y ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.december_y) : ''}</td>
<td className="table-text">{dep.january_y ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.january_y) : ''}</td>
<td className="table-text">{dep.february_y ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.february_y) : ''}</td>
<td className="table-text">{dep.march_y ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.march_y) : ''}</td>
<td className="table-text">{dep.april_y ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.april_y) : ''}</td>
<td className="table-text">{dep.may_y ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.may_y) : ''}</td>
<td className="table-text">{dep.june_y ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.june_y) : ''}</td>

          <td>

          </td>
      </tr>
      )}
</tbody>
 )
}
</table>
</div>

<div style={{ textAlign: 'left', fontWeight: 'bold',padding:"10px", fontSize: "14px" }}>
Warehouse Budget Deviation
    </div>
<div className="table-container">
<table className="table table-striped">
<thead>
<tr className="header-row-fixed">
  <td colSpan="2"> 
    <div className="input-group-container" style={{ display: "flex", justifyContent: "space-between", gap: "10px" }}>
      <div className="input-group mb-3" style={{ flex: 1 }}>
        <span className="input-group-text" style={{ fontSize: "12px" }}>Fiscal Year</span>
        <select
          className="form-select"
          value={this.state.fyname}
          onChange={this.changeFiscalYearBdwFilter}
          disabled={this.state.isEditClicked}
          style={{ fontSize: "12px" }}
        >
          <option value="">Select fiscal year</option>
          {this.state.fiscalYears.map((fiscalyear) => (
            <option key={fiscalyear} value={fiscalyear}>
              {fiscalyear}
            </option>
          ))}
        </select>
      </div>

      <div className="input-group mb-3" style={{ flex: 1 }}>
        <span className="input-group-text" style={{ fontSize: "12px" }}>Warehouse</span>
        <select
          className="form-select"
          value={this.state.warehouse}
          onChange={this.changeWarehouseNameFilter}
          disabled={this.state.isEditClicked}
          style={{ fontSize: "12px" }}
        >
          <option value="">Select warehouse</option>
          {this.state.warehouseNames.map((warehouse) => (
            <option key={warehouse} value={warehouse}>
              {warehouse}
            </option>
          ))}
        </select>
      </div>
    </div>
  </td>
</tr>



<tr className="header-row-fixed">
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      BudgetType
  </th>


  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Fiscal Year
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Region
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Warehouse
  </th>
 
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Jul
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Aug
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Sep
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Oct
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Nov
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Dec
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Jan
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Feb
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Mar
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Apr
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      May
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Jun
  </th>
</tr>
</thead>
{loading ? (
          <div style={{ display: 'flex',flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '40vh', width:'150vh' }}>
            {/* Use react-loader-spinner here */}
            <Blocks visible={true} height="100" width="100" ariaLabel="blocks-loading" wrapperStyle={{}} wrapperClass="blocks-wrapper"/>
            <div style={{ marginLeft: '10px' }}>Loading...</div>
          </div>
        ) : (
<tbody>
  {budgetdeviationwarehouse.map(dep=>
<tr key={dep.bdwid} className="row-hover">
<td className="table-text">{dep.budget_type_w ?? 'N/A'}</td>
<td className="table-text">{dep.fyname_w ?? 'N/A'}</td>
<td className="table-text">{dep.regionname_w ?? 'N/A'}</td>
<td className="table-text">{dep.warehousename_w ?? 'N/A'}</td>
<td className="table-text">{dep.july_w ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.july_w) : ''}</td>
<td className="table-text">{dep.august_w ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.august_w) : ''}</td>
<td className="table-text">{dep.september_w ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.september_w) : ''}</td>
<td className="table-text">{dep.october_w ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.october_w) : ''}</td>
<td className="table-text">{dep.november_w ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.november_w) : ''}</td>
<td className="table-text">{dep.december_w ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.december_w) : ''}</td>
<td className="table-text">{dep.january_w ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.january_w) : ''}</td>
<td className="table-text">{dep.february_w ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.february_w) : ''}</td>
<td className="table-text">{dep.march_w ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.march_w) : ''}</td>
<td className="table-text">{dep.april_w ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.april_w) : ''}</td>
<td className="table-text">{dep.may_w ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.may_w) : ''}</td>
<td className="table-text">{dep.june_w ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.june_w) : ''}</td>

          <td>
            

          </td>
      </tr>
      )}
</tbody>
 )
}
</table>
</div>

</div>
  )
}
  }




